import React from 'react';
import { IPage } from '../../../../interfaces/models/models/paginated-response.model';
import { IPaginationPayload } from '../../../../interfaces/shared/IPaginationPayload';
import Switch from '../../../../shared/switch';
import Table from '../../../../shared/table';

const tableColumns = ['Email', 'Username', 'Name', 'Role', 'Enabled', 'Actions']

interface IAgentsTable {
    rows: any;
    paginationData?: IPage;
    rowsLoading: boolean;
    setPaginationState: ({ pageNumber, pageSize }: IPaginationPayload) => void;
    onSeeAgentDetails: (data: any) => void;
    onEnableDisableAgent: (value: string, currentStatus: boolean) => void;
    onDeleteAgent: (id: string) => void;
    onEditAgent: (id: string, data: any) => void;
}

const AgentsTable = ({
    rows,
    paginationData,
    rowsLoading,
    setPaginationState,
    onEnableDisableAgent,
    onSeeAgentDetails,
    onDeleteAgent,
    onEditAgent
}: IAgentsTable) => {
    return (
        <Table
            columns={tableColumns}
            paginationData={paginationData}
            setPaginationState={setPaginationState}
        >
            {rowsLoading ?
                <>
                    {[...Array(4)].map((x, i) => {
                        return (
                            <tr key={i}>
                                {[...Array(tableColumns?.length || 1)].map((x, j) => {
                                    return (
                                        <td key={j} className='td-1 !min-w-[100%] text-center py-5'><span></span></td>
                                    )
                                })}
                            </tr>
                        )
                    })}
                </>
                : <>
                    {rows?.length > 0 && rows?.map((row: any, idx: number) => {
                        return (
                            <tr key={idx} className='bg-white border-b hover:bg-gray-50'>
                                <td className='px-6 py-4'>{row?.email}</td>
                                <td className='px-6 py-4'>{row?.username}</td>
                                <td className='px-6 py-4'>{row?.name} {row?.lastName}</td>
                                <td className='px-6 py-4'>{row?.cognitoGroups?.length >1 ? 'Admin' : 'Non-admin'}</td>
                                <td className={`px-6 py-4`}>
                                    <Switch
                                        checked={!!row?.enabled}
                                        onToggleSwitch={() => row?._id && onEnableDisableAgent(row?._id, row?.enabled || false)}
                                    />
                                </td>
                                <td className='px-4 py-4'>
                                    <div className='flex flex-row justify-around'>
                                        {row?.enabled && <div data-qa={'view-details'} onClick={() => row?.enabled && onSeeAgentDetails(row)}>
                                            <img title={'View Details'} alt='item details' src={'/assets/table-actions/visibility.svg'} className={'h-[14px] object-contain cursor-pointer mr-3'} />
                                        </div>
                                        }
                                        {row?.enabled && <div data-qa={'edit-details'} onClick={() => row?.enabled && onEditAgent(row?._id || '', row)}>
                                            <img title={'Edit Details'} alt='edit details' src={'/assets/table-actions/pen.svg'} className={'h-[14px] object-contain cursor-pointer mr-3'} />
                                        </div>
                                        }
                                        <div data-qa={'delete-agent'} onClick={() => row?._id && onDeleteAgent(row?._id)}>
                                            <img title={'Delete Member'} alt='delete item' src={'/assets/table-actions/delete-close.svg'} className={'h-[14px] object-contain cursor-pointer'} />
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        )
                    })}
                </>
            }
        </Table>
    )
}

export default AgentsTable;